import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
@Component({
  selector: 'app-loanpause',
  templateUrl: './loanpause.component.html',
  styleUrls: ['./loanpause.component.css']
})
export class LoanpauseComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private toastr: ToastrService, private appService: AppdataService,
    public loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private datePipe: DatePipe) {
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  isduplicate: boolean;

  loanpauseform = new FormGroup({
    loanid: new FormControl(0),
    ispauseloan: new FormControl(false),
    pauseon: new FormControl(null, Validators.required),
    resumeon: new FormControl(null, Validators.required),
    pausedesc: new FormControl('', Validators.required),
  });




  @Input() loanid: any = 0;
  @Input() ispauseloan: any = false;
  @Input() pauseon: any = null;
  @Input() resumeon: any = null;
  @Input() pausedesc: any = '';

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.loanpauseform.reset();
    this.fnInitializeFormGroup();


  }


  fnInitializeFormGroup() {
    this.loanpauseform.setValue({
      loanid: this.loanid,
      ispauseloan: this.ispauseloan,
      pauseon: this.pauseon,
      resumeon: this.resumeon,
      pausedesc: this.pausedesc,

    })
  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate

      if (this.loginService.fnCheckFornControlNotfound(this.loanpauseform.get('resumeon'))) {
        this.loanpauseform.controls['resumeon'].setErrors(null);
      }

      //Validate
      if (this.loanpauseform.valid) {

        if (this.loginService.fnCompareDateValidation(this.loanpauseform.get('resumeon').value, this.loanpauseform.get('pauseon').value)) {
          this.loanpauseform.controls['resumeon'].setErrors({ 'notfound': true });
          return
        }


        //Check
        var data = {
          loanid: this.loanid,
          ispauseloan: true,
          pauseon: this.fnFormatDatetime(this.loanpauseform.get('pauseon').value),
          resumeon: this.fnFormatDatetime(this.loanpauseform.get('resumeon').value),
          pausedesc: this.loanpauseform.get('pausedesc').value,
          pauseby: this.loginService.fnGetModUserId(),
        }
        this.appService.fnSetLoanPause(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              this.emitData.emit('DONE');
              this.activeModal.close(true);
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });





      }

    }
    catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnRemoveLoanBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
     
        //Check
        var data = {
          loanid: this.loanid,
          ispauseloan: false,
          pauseon: null,
          resumeon: null,
          pausedesc: '',
          pauseby: this.loginService.fnGetModUserId(),
        }
        this.appService.fnSetLoanPause(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              this.emitData.emit('DONE');
              this.activeModal.close(true);
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });

    }
    catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
